// TypeScript app
import "expose-loader?exposes=D12App!./main";

// Other dependencies
import "@fontsource/roboto";

// CoffeeScript app
importAll(require.context("coffee-loader!../../coffee", true, /\.coffee$/));

function importAll(r: __WebpackModuleApi.RequireContext) {
    r.keys().forEach(r);
}
